import { CSSProperties } from 'react';

import { HoverContentProps } from './hover-card.types';

import styles from './hover-card.module.css';

const HoverContent = ({ children, backgroundColor = 'transparent' }: HoverContentProps) => {
  return (
    <div
      className={`flex-column height-100-percent width-100-percent ${styles.hoverContent}`}
      data-component="HoverContent"
      style={
        {
          ...(backgroundColor && { '--hover-content-background-color': backgroundColor }),
        } as CSSProperties
      }
    >
      <>{children}</>
    </div>
  );
};

export default HoverContent;
